export const TOGGLE_APP_STATE = 'TOGGLE_APP_STATE'
export const SET_VERSION_INFO = 'SET_VERSION_INFO'
export const SET_AUTOMATIC_UPDATE = 'SET_AUTOMATIC_UPDATE'

export const toggleAppState = newState => ({ payload: newState, type: TOGGLE_APP_STATE })

export const setVersionInfo = (payload) => ({
    type: SET_VERSION_INFO,
    payload,
})

export const setAutomaticUpdate = (payload) => ({
  type: SET_AUTOMATIC_UPDATE,
  payload,
})
